import { ResponseType, PaginationResponseType, PageRequest, PoiConfigurationCriteria } from '@types';
import { PoiConfigurationType } from '@types';
import { axios, get, post, put } from './baseAxios';
import { API_POI_CONFIGURATIONS } from './urls';

const url = API_POI_CONFIGURATIONS;

const create = (request: PoiConfigurationType): Promise<ResponseType<PoiConfigurationType>> =>
  post(`${url}`, request);

const update = (
  id: number,
  request: PoiConfigurationType
): Promise<ResponseType<PoiConfigurationType>> => put(`${url}/${id}`, request);

const deleteById = (id: number): Promise<ResponseType<boolean>> => axios.delete(`${url}/${id}`);

const getById = (id: number): Promise<ResponseType<PoiConfigurationType>> => get(`${url}/${id}`);

const filter = (
  request: PageRequest & PoiConfigurationCriteria
): Promise<PaginationResponseType<PoiConfigurationType[]>> =>
  get(`${url}`, { params: { ...request } });

export { create, update, deleteById, getById, filter };
